import script from "./DailyReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyReservation.vue?vue&type=script&setup=true&lang=js"

import "./DailyReservation.vue?vue&type=style&index=0&id=48e1dbde&lang=less&scoped=true"

import exportComponent from "D:\\yisa_project\\访客预约系统\\vrs_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e1dbde"]])

export default __exports__